export default "__VITE_ASSET__BH8ei1Zn__"